export const formatFileSize = (size: number): string => {
  if (size < 1024) {
    return formatSizeWithUnit(size, 'B');
  }
  if (size < 1024 * 1024) {
    return formatSizeWithUnit(size / 1024, 'KB');
  }
  if (size < 1024 * 1024 * 1024) {
    return formatSizeWithUnit(size / 1024 / 1024, 'MB');
  }
  return formatSizeWithUnit(size / 1024 / 1024 / 1024, 'GB');
};

const formatSizeWithUnit = (size: number, unit: string): string => {
  if (size < 10) {
    return `${size.toFixed(2)} ${unit}`;
  }
  if (size < 100) {
    return `${size.toFixed(1)} ${unit}`;
  }
  return `${Math.round(size)} ${unit}`;
};
